import debounce from 'lodash.debounce'
import React from 'react'
import { useSelector } from 'react-redux'
import {
  FormLabel,
  FormDashboardInput as FormInput,
  FormRow,
  PinPointInput
} from '../../../components'
import { provinceFirstLabel } from '../../../constants'
import { CityDropdown } from '../../../features/cities/components/city-dropdown'
import { CitiesProvider } from '../../../features/cities/hook'
import { ProvinceDropdown } from '../../../features/provinces/components/province-dropdown'
import { ProvincesProvider } from '../../../features/provinces/hook'
import { formUpdater, inputNormalizer } from '../../../utils'

const FormContact = ({ onChange }) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const [form, setForm] = React.useState({})

  const updateForm = debounce((e) => formUpdater(e, form, setForm), 250)

  React.useEffect(() => {
    if(typeof onChange === 'function'){
      onChange(form)
    }
    //eslint-disable-next-line
  }, [form])

  const handlePinPoint = (value) => {
    const result = `${value.lat}, ${value.lng}`
    inputNormalizer(result, 'pin_point', updateForm)
  }

  return (
    <>
      <h2 className="text-lg mb-5 lg:mb-8 font-primary font-bold">
        {translation.ORGANIZATION.contact_info[language.name]}
      </h2>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.pic[language.name]}
        </FormLabel>
        <FormInput
          name="pic_name"
          className="w-full"
          placeholder={translation.ORGANIZATION.pic_enter[language.name]}
          onChange={(e) => {e.persist(); updateForm(e)}}
          required
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.pic_phone[language.name]}
        </FormLabel>
        <FormInput
          name="phone"
          type="tel"
          className="w-full"
          placeholder={translation.ORGANIZATION.phone_enter[language.name]}
          onChange={(e) => {
            e.persist();
            updateForm(e);
          }}
          required
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.website[language.name]}
        </FormLabel>
        <FormInput
          name="website"
          className="w-full"
          placeholder="https://example.com"
          defaultValue="https://"
          onChange={(e) => {
            e.persist();
            updateForm(e);
          }}
          required
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.ORGANIZATION.office_phone_number[language.name]}
        </FormLabel>
        <FormInput
          name="phone_org"
          type="tel"
          className="w-full"
          placeholder={translation.ORGANIZATION.phone_enter[language.name]}
          onChange={(e) => {
            e.persist();
            updateForm(e);
          }}
          required
        />
      </FormRow>

      <FormRow>
        <ProvincesProvider>
          <ProvinceDropdown updateForm={updateForm} />
        </ProvincesProvider>
      </FormRow>

      {
        (form.province && form.province.value) ? (
          <FormRow>
            <CitiesProvider provinceId={form.province?.value}>
              <CityDropdown updateForm={updateForm} />
            </CitiesProvider>
          </FormRow>
        ) : (
          <FormRow>
            <FormLabel>
              {translation.GENERAL.city[language.name]}
            </FormLabel>
            <p className="text-sm text-gray-600">
              {provinceFirstLabel[language.name]}
            </p>
          </FormRow>
        )
      }

      <FormRow>
        <FormLabel>
          {translation.GENERAL.address[language.name]}
        </FormLabel>
        <FormInput
          name="address"
          className="w-full"
          placeholder={translation.GENERAL.address_enter[language.name]}
          onChange={(e) => {
            e.persist();
            updateForm(e);
          }}
          required
        />
      </FormRow>

      <FormRow>
        <FormLabel>
          {translation.GENERAL.pin_point[language.name]}
        </FormLabel>
        <PinPointInput onChange={handlePinPoint} />
      </FormRow>
    </>
  );
}

export { FormContact }
